import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";

function Group(props) {
  const { params } = props.match;
  const accountId = parseInt(params.accountId, 10);

  const { request } = useApi();
  const auth = useAuth();
  const stateError = useError();
  const messages = message();

  const [account, setAccount] = React.useState({id:null, name: ""});

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - 多メディア収集グループ登録";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchAccount();
  }, [auth.state.token]);

  const fetchAccount = () => {
    request({
      method: "GET",
      url: `admin/accounts/${accountId}`,
    }).then((result) => {
      setAccount({
        id: result.data.data.id,
        name: result.data.data.name,
      });
    });
  }

  const handleSubmit = (group) => {
    request({
      method: "POST",
      url: `admin/media/${accountId}/groups`,
      data: {
        name: group.name,
        desc: group.desc,
        priority: parseInt(group.priority, 10),
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push(`/admin/media/accounts/group/${accountId}?success=create`);
      })
      .catch((errors) => {
        let errorMsg = messages.validation.common;

        // エラーの内容が収集グループ名の重複かチェック
        // 重複の場合、エラーメッセージを変更
        if(errors.response.data.errors.name){
          (errors.response.data.errors.name).map((error) => {
            if (error.error === "taken") {
              errorMsg = (messages.validation.taken).replace("$1", "収集グループ名");
            }
          })
        }
        
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: errorMsg,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          account={account}
          submit={handleSubmit}
        />
      }
    />
  );
}
export default withRouter(Group);
